import {
  flightsRebookPlanApi,
  flightsRebookSlice,
  type FlightsRebookState,
} from "~core-flights-rebook/features";

export interface FlightsRebookAppState {
  flightsRebook: FlightsRebookState;
}

export const flightsRebookReducers = {
  flightsRebook: flightsRebookSlice.reducer,
  [flightsRebookPlanApi.reducerPath]: flightsRebookPlanApi.reducer,
};

export const flightsRebookMiddleware = [flightsRebookPlanApi.middleware];
